import { render, staticRenderFns } from "./store-badge.vue?vue&type=template&id=6bf5e818&scoped=true&"
import script from "./store-badge.vue?vue&type=script&lang=js&"
export * from "./store-badge.vue?vue&type=script&lang=js&"
import style0 from "./store-badge.vue?vue&type=style&index=0&id=6bf5e818&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf5e818",
  null
  
)

export default component.exports